<template>
  <asc-navigation-manager
    :notifications="notifications"
    :collapsed="collapsed"
    :on-size-change="onSizeChange"
    :on-manage-gaf="onManageGaf"
    :router="router"
    :on-log-out="onLogOut"
    :profile="profile"
    :feature-flags="featureFlags"
    :global-filter-text="globalFilterText"
    :global-filter-tooltip="globalFilterTooltip"
    :global-filter-active="globalFilterActive"
    :global-filter-enabled="globalFilterEnabled"
    :global-filter-disabled="globalFilterDisabled"
    :global-filter-visible="globalFilterVisible"
    :user-roles="userRoles"
    :user-airlines="userAirlines"
    :user-permissions="userPermissions"
    data-automation-id="wrapper_navigation"
  >
  </asc-navigation-manager>
</template>

<script>
import AscNavigationManager from '@/components/molecules/AscNavigationManager'

export default {
  name: 'AscNavigationWrapper',

  components: {
    AscNavigationManager,
  },

  props: {
    notifications: {
      type: Object,
      default: () => {
        return {
          primaryLinks: [],
          secondaryLinks: [],
        }
      },
    },
    collapsed: {
      type: Boolean,
      default: true,
    },
    onSizeChange: {
      type: Function,
      default: () => {},
    },
    onManageGaf: {
      type: Function,
      default: () => {},
    },
    router: {
      type: Object,
      default: () => {},
    },
    onLogOut: {
      type: Function,
      default: () => {},
    },
    profile: {
      type: Object,
      default: () => {},
    },
    featureFlags: {
      type: Object,
      default: () => {},
    },
    globalFilterText: {
      type: String,
      default: '',
    },
    globalFilterTooltip: {
      type: String,
      default: '',
    },
    globalFilterActive: {
      type: Boolean,
      default: false,
    },
    globalFilterEnabled: {
      type: Boolean,
      default: false,
    },
    globalFilterDisabled: {
      type: Boolean,
      default: false,
    },
    globalFilterVisible: {
      type: Boolean,
      default: false,
    },
    userRoles: {
      type: Array,
      default: () => [],
    },
    userPermissions: {
      type: Array,
      default: () => [],
    },
    userAirlines: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
